import { CssBaseline, ThemeProvider } from "@mui/material"
import { Route, Routes } from "react-router-dom"
import Actions from "./carlton/action"
import ModuleCategorys from "./carlton/module-categories"
import ModulePermissions from "./carlton/module-permissions"
import Projects from "./carlton/project"
import ProjectModules from "./carlton/project-modules"
import ProjectPermissions from "./carlton/project-permissions"
import Roles from "./carlton/role"
import Users from "./carlton/user"
import UserRole from "./carlton/user-role"
import Form from "./carlton/user/form"
import Dashboard from "./scenes/dashboard"
import Sidebar from "./scenes/global/Sidebar"
import Topbar from "./scenes/global/Topbar"
import { ColorModeContext, useMode } from "./theme"
import { useEffect, useState } from "react"
import {
	loadFromLocalStorage,
	saveToLocalStorage,
} from "./services/security/secureStorage"
import { decryptData } from "./services/security/cryptographicOperations"
import Loading from "./components/Loading"
import {
	getUrlUserInfo,
	getUserHealth,
} from "./services/security/securityUtils"

function App() {
	const [theme, colorMode] = useMode()
	const [loading, setLoading] = useState(false)
	const [user, setUser] = useState()

	// useEffect(() => {
	// 	setLoading(true)

	// 	// checkUserPermissionHealth()

	// 	function userProcess() {
	// 		const user = getUrlUserInfo()
	// 		// const localUser = JSON.parse(loadFromLocalStorage("user"))
	// 		const localUser = loadFromLocalStorage("user")
	// 		setUser(user)
	// 		if (!user && !localUser) {
	// 			window.location.href = `${process.env.REACT_APP_DASHBOARD_URL}/home`
	// 			//return
	// 		}
	// 		user && saveToLocalStorage("user", user)
	// 	}
	// 	userProcess()

	// 	setLoading(false)
	// }, [])

	const checkUserPermissionHealth = async () => {
		const response = await getUserHealth()

		if (response.status === 200) {
			return true
		}
		// AlertService.errorNotify("User Permission Not working")
		const timeout = setTimeout(() => {
			window.location.href = `${process.env.REACT_APP_DASHBOARD_URL}`
		}, 5000)
		return false
	}

	return (
		<ColorModeContext.Provider value={colorMode}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<Loading isLoading={loading} />
				<div className="app">
					<Sidebar />
					<main className="content">
						<Topbar />
						<Routes>
							<Route path="/" element={<Dashboard />} />
							<Route path="/users" element={<Users />} />
							<Route path="/create-user" element={<Form />} />
							<Route path="/projects" element={<Projects />} />
							<Route path="/roles" element={<Roles />} />
							<Route path="/actions" element={<Actions />} />
							<Route path="/module-categories" element={<ModuleCategorys />} />
							<Route path="/project-modules" element={<ProjectModules />} />
							<Route path="/user-role-assignment" element={<UserRole />} />
							<Route
								path="/project-permissions"
								element={<ProjectPermissions />}
							/>
							<Route
								path="/module-permissions"
								element={<ModulePermissions />}
							/>
						</Routes>
					</main>
				</div>
			</ThemeProvider>
		</ColorModeContext.Provider>
	)
}

export default App
